import Header from 'components/Header'
import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Dispatch } from 'redux'
import {
  displayedCurrencyCodes,
  getSiteCurrencyFromAPI,
  setCurrency,
  SiteCountry,
  SiteCurrencyCode,
} from '../../data/models/locale'
import { AppDispatch, AppState } from '../../data/state'
import BookButton from './BookButton'
import CountrySelect from './country_select'
import LoginComponent from './login_component'
import { LogoLink } from './logo_link'
import MenuLink from './menu_link'

interface NavBarProps extends PropsFromRedux {
  match: any
  type?: string
  hideMenu?: boolean
  confirmCountryChange?: boolean
  overrideColour?: 'black' | 'white'

  setCurrency(value: string): void
}

const NavBar: React.FC<NavBarProps> = props => {
  return (
    <Header
      type={props.type}
      logoLink={<LogoLink />}
      languageLinks={
        <CountrySelect
          match={props.match}
          showConfirmation={props.confirmCountryChange}
        />
      }
      menuLinks={<MenuLink match={props.match} />}
      bookButton={<BookButton />}
      loginComponent={<LoginComponent />}
      currentCountry={props.country}
      onChangeCurrency={props.setCurrency}
      availableCurrencies={displayedCurrencyCodes}
      hideMenu={props.hideMenu}
      overrideColour={props.overrideColour}
    />
  )
}

const mapStateToProps = (state: AppState) => ({
  memberToken: state.member.token,
  country: state.locale.country,
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  setCurrency: (currency: SiteCurrencyCode) => {
    dispatch(setCurrency(getSiteCurrencyFromAPI(currency)))
  },
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(NavBar)
